module.exports = __webpack_public_path__ + "img/login-img5@2x.403ec843.png";